import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const TravelTourismManagementHeader = () => {
  return (
    <CourseHeader
      title="Travel & Tourism"
      highlight="Management"
      subtitle="Explore. Serve. Inspire."
      backgroundImage="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default TravelTourismManagementHeader;
